import Repository from './Repository';
import TokenService from '../helpers/token';

const resource = Repository.defaults.erpUrl;

export default {
  async getGroupTickets(params) {
    const response = await Repository.get(`${resource}/ticket/ticket-template`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async fgApiSet(payload) {
    // eslint-disable-next-line no-return-await
    return await Repository.post(`${resource}/fg/set`, payload);
  },
  async getListSupportsV2(params) {
    const response = await Repository.get(`${resource}/ticket`, {
      params,
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async getTicketDetail(id) {
    const response = await Repository.get(`${resource}/ticket/${id}`, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
  async getLevelTicketApi(subjectId) {
    const response = await Repository.get(`${resource}/subject/${subjectId}`, {
      headers: TokenService.getHeader(),
    });
    return response;
  },
};
